import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import {
  type InputFormData,
  type OutputFormData,
} from '@ikea-customer-self-serve/contact-form';

interface InputFormDataWithFileConsent extends InputFormData {
  hasConsent?: boolean;
}

const initialState: InputFormDataWithFileConsent = {};

const contactSlice = createSlice({
  name: 'contact',
  initialState,
  reducers: {
    updateContactState: (state, action: PayloadAction<OutputFormData>) => {
      const formData = action.payload;
      return {
        ...state,
        ...formData,
        address2: formData.address2 || undefined,
        allowPersonalEmail: formData.allowPersonalEmail ?? undefined,
        businessName: formData.businessName || undefined,
        allowSalesProfileSharing:
          formData.allowSalesProfileSharing ?? undefined,
        foreignCountry: formData.foreignCountry || undefined,
        address1: formData.address1 !== 'N/A' ? formData.address1 : undefined,
        city: formData.city !== 'N/A' ? formData.city : undefined,
        postCode: formData.postCode !== 'N/A' ? formData.postCode : undefined,
        state: formData.state !== 'N/A' ? formData.state : undefined,
      };
    },
    clearContactState: () => initialState,
    updateHasFileConsent: (
      state,
      action: PayloadAction<{ hasConsent: boolean }>,
    ) => {
      state.hasConsent = action.payload.hasConsent;
    },
  },
});

export const { updateHasFileConsent, updateContactState, clearContactState } =
  contactSlice.actions;

export default contactSlice.reducer;
